export function saveValue(key: string, value: any) {
    // Create cookie
    document.cookie = `${key}=${value}`;
}

export function getValue(key: string) {
    // Get cookie
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(key + '=')) {
            return cookie.substring(key.length + 1);
        }
    }
    return null;
}

export function deleteValue(key: string) {
    // Delete cookie
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function getCachedTheme(): 'light' | 'dark' {
    const cachedTheme = getValue('theme');
    if (cachedTheme === 'light' || cachedTheme === 'dark') {
        return cachedTheme;
    }
    return 'dark';
}

export function setCachedTheme(theme: 'light' | 'dark') {
    saveValue('theme', theme);
}